import { useMemo } from 'react';

import { useLoggedInUserRoles } from '~/components/Auth';
import { Roles } from '~/data/user';
import { useSelectedEmployeeId } from '~/hooks/employee';
import { employeeModulesAccessRoles } from '~/scenes/PortalViews/Views/EmployeeViews/data';
import { hasOneOfRoles } from '~/services/Permissions';

export const useModuleAccess = () => {
  const {
    isSelectedEmployeeLoggedInUser,
    selectedEmployeeDetails: { hasRoleAccessOverEmployee },
  } = useSelectedEmployeeId();
  const myRoles = useLoggedInUserRoles();

  return useMemo(() => {
    const hasRoleAccess = (roles: Roles[]) => hasOneOfRoles(myRoles, roles);

    // NOTE: In Legacy some non-employee related modules access is still depended on selected employee
    const hasRoleAccessOverEmployeeOnAllModules = hasRoleAccessOverEmployee(
      employeeModulesAccessRoles.allModules,
    );

    return {
      people: true,
      rewarding:
        isSelectedEmployeeLoggedInUser ||
        hasRoleAccessOverEmployee(employeeModulesAccessRoles.rewarding),
      performance:
        isSelectedEmployeeLoggedInUser ||
        hasRoleAccessOverEmployee(employeeModulesAccessRoles.performance),
      development:
        isSelectedEmployeeLoggedInUser ||
        hasRoleAccessOverEmployee(employeeModulesAccessRoles.development),
      analytics:
        isSelectedEmployeeLoggedInUser || hasRoleAccessOverEmployeeOnAllModules, // TODO: Check condition
      collaboration:
        isSelectedEmployeeLoggedInUser || hasRoleAccessOverEmployeeOnAllModules, // TODO: Check condition
      organization: true,
      recruiting: hasRoleAccessOverEmployeeOnAllModules, // TODO: Check condition
      planning: hasRoleAccessOverEmployeeOnAllModules, // TODO: Check condition
      admin: hasRoleAccess([
        Roles.HR_ADMIN,
        Roles.HR_ADMIN_LIMITED,
        Roles.HR_STAFF,
        Roles.HR_DEV,
      ]),
    };
  }, [isSelectedEmployeeLoggedInUser, hasRoleAccessOverEmployee, myRoles]);
};
